import { template } from './templates';

/* @ngInject */
export function cacheTemplates ($templateCache) {
	$templateCache.put('fine-uploader/templates/view.html', template);
}
